import React from "react";
import styled from "styled-components";
import { useLoyalty, useTheme } from "../../hooks/";
import { StyledText } from "../../components/common/basic";
import { useHistory } from "react-router-dom";
import OfferCards from "../loyalty/offerCards";
import { OfferCard } from "../loyalty";

const EventsView = () => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const history = useHistory();

  const {
    events,
    loyaltyOffersData,
    eventOffersData,
    setOfferModal,
    setSelectedLoyaltyData,
    businessChallengeVotingDetails,
  } = useLoyalty();

  const { isActive, title, description, imageUrl } =
    businessChallengeVotingDetails || {};
  const all = [...events, ...loyaltyOffersData];
  const past = all.filter((ev) => ev.category === "past");
  const upcoming = all.filter((ev) => ev.category === "upcoming");
  const live = all.filter(
    (ev) => ev.category === "live" || ev.category === "today"
  );
  const categoryViews = [
    { title: "Live", list: live },
    { title: "Upcoming", list: upcoming },
    { title: "Past", list: past },
  ];

  return (
    <div>
      {isActive && (
        <div>
          <OfferHeader>
            <StyledText style={{ fontSize: "18px", fontWeight: "bold" }}>
              Voting
            </StyledText>
          </OfferHeader>
          <div
            style={{
              display: "grid",
              gap: "0px",
              grid: "auto / 50% 50%",
              maxWidth: "370px",
              margin: "0 auto",
            }}
          >
            <OfferCard
              margin={"0 15px"}
              lock={false}
              title={title}
              description={description}
              backgroundImage={imageUrl}
              onClick={() => history.push("/business_challenge")}
            />
          </div>
        </div>
      )}
      {categoryViews
        .filter((cat) => cat.list?.length)
        .map(({ title, list }) => (
          <div key={title}>
            <OfferHeader>
              <StyledText style={{ fontSize: "18px", fontWeight: "bold" }}>
                {title} Events
              </StyledText>

              <ViewAllHolder onClick={() => history.push(`events`)}>
                <StyledText
                  style={{
                    fontSize: "14px",
                    fontFamily: "MTNRegular",
                    margin: "1px 0 0 0",
                  }}
                  color={background}
                >
                  View all
                </StyledText>
              </ViewAllHolder>
            </OfferHeader>
            <div
              style={{
                display: "grid",
                gap: "0px",
                grid: "auto / 50% 50%",
                maxWidth: "370px",
                margin: "0 auto",
              }}
            >
              <OfferCards
                cardMargin="10px auto"
                offers={list}
                setData={setSelectedLoyaltyData}
                setModal={setOfferModal}
                history={history}
              />
            </div>
          </div>
        ))}
    </div>
  );
};

export default EventsView;

const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 20px;
`;

const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
